var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"mb-1"},[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":""},model:{value:(_vm.isDelivered),callback:function ($$v) {_vm.isDelivered=$$v},expression:"isDelivered"}},[_vm._v("Yard Delivery")])],1),_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }